"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Image;
exports.useThemeSrc = useThemeSrc;
exports.withThemeSrc = withThemeSrc;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _head = _interopRequireDefault(require("lodash/head"));
var _values = _interopRequireDefault(require("lodash/values"));
var _styles = require("@material-ui/core/styles");
var _constants = require("../../utils/constants");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function Image(props) {
  var src = useThemeSrc(props.src);
  return /*#__PURE__*/_react["default"].createElement("img", (0, _extends2["default"])({}, props, {
    src: src,
    alt: props.alt
  }));
}
function withThemeSrc() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var srcs = args.filter(Boolean);
  if (srcs.length === 1) return srcs[0];else if (srcs.length > 1) {
    var _srcs = (0, _slicedToArray2["default"])(srcs, 2),
      lightSrc = _srcs[0],
      darkSrc = _srcs[1];
    return (0, _defineProperty2["default"])((0, _defineProperty2["default"])({}, _constants.themeMode.LIGHT, lightSrc), _constants.themeMode.DARK, darkSrc);
  }
  return '';
}
function useThemeSrc(src) {
  var _useTheme = (0, _styles.useTheme)(),
    palette = _useTheme.palette;
  return (0, _react.useMemo)(function () {
    if ((0, _typeof2["default"])(src) === 'object') {
      return src[palette.type] || (0, _head["default"])((0, _values["default"])(src));
    } else {
      return src;
    }
  }, [src, palette.type]);
}
//# sourceMappingURL=index.js.map